// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XVRo","title":"styles_title__YMv85"};